module.exports = __webpack_public_path__ + "files/b348357e35677da79b5ca21270e2633d.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-300italic.svg
// module id = 1137
// module chunks = 76